import { DEFAULT_STATE } from '../components/address/validations';

const isControllerEmpty = (controller) => {
  let isEmpty = true;
  if (controller) {
    const {
      firstName,
      lastName,
      type,
      ssn,
      address
    } = controller;

    if (address) {
      const {
        street,
        city,
        state,
        zip
      } = address;

      isEmpty = !(firstName && lastName && type && ssn && street && city && (state && state !== DEFAULT_STATE) && zip);
    }
  }
  return isEmpty;
};

export default isControllerEmpty;

